import {default as SearchAreaPC} from '@/components/help/pc/common/SearchArea';
import {default as SearchAreaMobile} from '@/components/help/mobile/common/SearchArea';
import {useHelpContext} from '@/app/(main)/routes/help/context/HelpContext';

const SearchArea = () => {
  const {isMobile} = useHelpContext();
  return isMobile ? <SearchAreaMobile /> : <SearchAreaPC />;
};

export default SearchArea;
